import { Component, Input } from '@angular/core';
import { ProductVariant } from '../data/models';

@Component({
    selector: 'app-product-variant-details[selectedVariant]',
    styles: [`
  `],
    template: `
    <div class="d-block square-image-m bg-light shadow-sm border d-flex flex-shrink-0"
         [style.background-image]="selectedVariant && selectedVariant.images.length > 0 && selectedVariant.images[0].url && 'url(' + selectedVariant.images[0].url + ')'"></div>
    <span class="fw-bold pt-3 ps-3 pe-3 text-center">{{selectedVariant?.title}}</span>
    <div class="pt-3 d-flex pb-3">
      <div class="d-flex flex-column pe-3 fw-lighter">
        <span i18n>Art-Nr:</span>
        <span i18n>VK:</span>
        <span i18n>UPE:</span>
        <span i18n>Hersteller:</span>
        <span i18n>Kategorie:</span>
      </div>
      <div class="d-flex flex-column">
        <span>{{selectedVariant?.code}}</span>
        <span>{{selectedVariant?.price | currency}}</span>
        <span *ngIf="selectedVariant?.compareAtPrice">{{selectedVariant?.compareAtPrice | currency}}</span>
        <span *ngIf="!selectedVariant?.compareAtPrice">-</span>
        <span>{{selectedVariant?.vendor}}</span>
        <span *ngIf="selectedVariant?.category">{{selectedVariant?.category}}</span>
      </div>
    </div>
    <div class="pt-3 border-top w-100">
      <span class="ps-3 pe-3 fw-bold" i18n>Beschreibung</span>
      <p class="ps-3 pt-3" [innerHTML]="selectedVariant?.description"></p>
    </div>
    <ng-content></ng-content>
  `,
    standalone: false
})
export class ProductDetailsVariantComponent {
  @Input() selectedVariant: ProductVariant | null = null;
}
